var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hold",
    transform: "translate(-17 -5.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5291",
    "data-name": "Group 5291",
    transform: "translate(17 5.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M24.129,958.364a1.875,1.875,0,0,0-1.816,1.412,1.869,1.869,0,0,0-2.659,1.374A1.869,1.869,0,0,0,17,962.818v7.5h0c.006,2.044.064,3.924.088,6.1h0a5.508,5.508,0,0,0,1.891,4.141,7.568,7.568,0,0,0,4.169,1.754c3.107.348,6.576-.991,7.823-4.315h0a17.626,17.626,0,0,0,.768-3.068c.175-.564.588-1.165,2.346-2.777h0a2.058,2.058,0,0,0,.67-2.6,1.632,1.632,0,0,0-1.218-.673,3.486,3.486,0,0,0-1.729.35h0A12.128,12.128,0,0,0,29.53,970.6a10.022,10.022,0,0,0-.9.771v-8.559A1.868,1.868,0,0,0,26,961.137v-.931a1.865,1.865,0,0,0-1.869-1.844Zm0,1.091a.756.756,0,0,1,.763.753v8.311a.553.553,0,0,0,1.106,0v-5.7a.762.762,0,0,1,1.523,0v10.189c0,.5.83.648,1.079.223a5.448,5.448,0,0,1,1.608-1.762,11.391,11.391,0,0,1,2.052-1.249h0a2.467,2.467,0,0,1,1.168-.26c.252.025.348.1.4.187.111.166.112.644-.5,1.2h0c-1.8,1.647-2.394,2.43-2.651,3.257a21.231,21.231,0,0,1-.747,3.008h0c-1.05,2.8-3.954,3.913-6.662,3.61a6.5,6.5,0,0,1-3.556-1.483,4.351,4.351,0,0,1-1.523-3.339h0c-.025-2.185-.083-4.062-.088-6.087h0v-7.5a.763.763,0,0,1,1.526,0v6.15a.553.553,0,0,0,1.106,0v-7.536a.762.762,0,0,1,1.523,0v6.906a.553.553,0,0,0,1.106,0v-8.13a.756.756,0,0,1,.763-.753Z",
    transform: "translate(-17 -958.362)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.7b9984dbea7f42f3bc3557623d7bd3a3.svg";
export { ForwardRef as ReactComponent };